
export default {
  name: "Input",
  props: {
    textarea: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 5,
    },
    inputClass: {
      type: String,
      default: "",
    },
    inputId: {
      type: String,
      default: "",
      require: true,
    },
    placeholder: {
      type: String,
      default: "Your Name",
    },
    requireCondition: {
      type: Boolean,
      default: false,
    },
    showMessage: {
      type: Boolean,
      default: false,
    },
    showClear: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      inputVal: "",

      pollingInterval: null,
    };
  },
  computed: {
    showRequire() {
      return this.requireCondition && this.showMessage;
    },
  },
  watch: {
    inputVal(newVal, oldVal) {
      this.$emit("input", newVal);
      this.$emit("enter", newVal);
    },
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  mounted() {
    this.setupInput();
  },
  methods: {
    handleClear() {
      this.inputVal = "";
      document.querySelector(`#${this.inputId}`).value = "";
    },
    setupInput() {
      const oInput = document.getElementById(`${this.inputId}`);
      this.inputVal = oInput.value;

      this.pollingInterval = setInterval(() => {
        if (oInput.value !== this.inputVal) {
          this.inputVal = oInput.value;
        }
      }, 100);
    },
  },
};
